import React, { useEffect, useState } from "react"
import { formatDateString } from "../../util/common"
import styles from "./project.css";
import data from "./data";
import { Chips } from "../AboutContent/about-content";

const ProjectLinks = ({ urls }) => {
    return urls.map((url, ind) => (
        <a target="_blank" href={url.link} key={url.title + ind}>{url.title}</a>
    ))
}

const ProjectContent = ({ detail }) => {

    return (
        <div className="content clear" >
            <div className="project-container">
                {
                    data.projects.map((project, ind) => (
                        <div className="box" key={project.title + ind}>
                            <div className="project-content">
                                <h1>{project.title}</h1>
                                <ProjectLinks urls={project.urls} />
                                <p>{project.description}</p>
                                <Chips data={project.tags} />
                            </div>
                            <div className="image-slider">
                                <img src={project.images[0].src} alt={project.images[0].alt} />
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ProjectContent;
